import { LOCAL_STORAGE } from 'utils/constants';

let accessToken = window.sessionStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN);
let accessRecruitmentToken = window.sessionStorage.getItem(LOCAL_STORAGE.ACCESS_RECRUITMENT_TOKEN);
let refreshToken = window.localStorage.getItem('refreshToken');

export const getAccessToken = (): string | null => accessToken;
export const getAccessRecruitmentToken = (): string | null => accessRecruitmentToken;

export const setAccessToken = (token: string): void => {
  accessToken = token;
  window.sessionStorage.setItem(LOCAL_STORAGE.ACCESS_TOKEN, token);
};

export const setAccessRecruitmentToken = (token: string): void => {
  accessRecruitmentToken = token;
  window.sessionStorage.setItem(LOCAL_STORAGE.ACCESS_RECRUITMENT_TOKEN, token);
};

export const getRefreshToken = (): string | null => refreshToken;

export const setRefreshToken = (token: string): void => {
  refreshToken = token;
  window.sessionStorage.setItem('refreshToken', token);
};

export const removeAccessToken = (): void => {
  accessToken = null;
  window.sessionStorage.removeItem(LOCAL_STORAGE.ACCESS_TOKEN);
};

export const removeAccessRecruitmentToken = (): void => {
  accessRecruitmentToken = null;
  window.sessionStorage.removeItem(LOCAL_STORAGE.ACCESS_RECRUITMENT_TOKEN);
};

export const setLocalStorage = (name: string, value: string) => {
  window.localStorage.setItem(name, value);
};

export const removeLocalStorage = (name: string) => {
  window.localStorage.removeItem(name);
};

export const getLocalStorage = (name: string): string | null => window.localStorage.getItem(name);

export const clearLocalStorage = () => {
  window.localStorage.clear();
};
